import { DesignProp, GeneralProp } from "../PropCategories";

export const fontWeight = {
  prop: "style-attribute",
  name: "Font Weight",
  nameI18n: "builder_ui.prop_type.styles.font_weight",
  category: [DesignProp, GeneralProp],
  type: "select",
  defaultValue: "500",
  options: [
    {
      label: "Normal",
      labelI18n: "builder_ui.prop_type.styles.font_weight_types.normal",
      value: "400",
    },
    {
      label: "Medium",
      labelI18n: "builder_ui.prop_type.styles.font_weight_types.medium",
      value: "500",
    },
    {
      label: "Semibold",
      labelI18n: "builder_ui.prop_type.styles.font_weight_types.semibold",
      value: "600",
    },
    {
      label: "Bold",
      labelI18n: "builder_ui.prop_type.styles.font_weight_types.bold",
      value: "700",
    },
  ],
} as const;
